import { createContext } from "react";

import type { AgentRun } from "./useAgentRun";

export interface AgentRunContextValue {
    /** The modal is shown; false while minimized to the pill or without a run. */
    isOpen: boolean;
    /** A run exists and has not finished. */
    isActive: boolean;
    /** A run exists, finished or not, until it is closed; it belongs to the company it was opened for. */
    hasRun: boolean;
    /** Reopens the active run, otherwise starts a fresh one. */
    open(): void;
    minimize(): void;
    /** Ends the run and disposes it. */
    close(): void;
    run: AgentRun | null;
}

const noop = (): void => undefined;

/** The one Binale Agent run of the app; links in the chat and report minimize through it. */
export const AgentRunContext = createContext<AgentRunContextValue>({
    isOpen: false,
    isActive: false,
    hasRun: false,
    open: noop,
    minimize: noop,
    close: noop,
    run: null,
});
